import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Dashboard from "../Layout/Dashboard";
import { getUsers } from "../../actions/users";
import { getProducts } from "../../actions/products";
import { getOrders } from "../../actions/orders";
import { getTotalIncome } from "../../actions/totalincome";
import { Skeleton } from "antd";
import { getStores } from "../../actions/store";
import { formatDate } from "../../utils/Utils";

const Main = ({ storeCurrency, currentUser, superAdmin }) => {
  const [loading, setLoading] = useState(true);
  const productCount = useSelector((state) => state.products)?.length;
  const orderCount = useSelector((state) => state.orders)?.length;
  const totalIncome = useSelector((state) => state.totalIncome);
  const userData = useSelector((state) => state?.users);
  const allStores = useSelector((state) => state.stores);
  const data = allStores?.filter((item) => item?._id !== currentUser?.store);

  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    if (currentUser) {
      setTimeout(() => {
        dispatch(getProducts(currentUser.store));
        dispatch(getOrders(currentUser.store));
        dispatch(getUsers(currentUser.store, "CUSTOMER"));
        dispatch(getTotalIncome(currentUser.store));
        setLoading(false);
      }, 2000);
    }
    dispatch(getStores());
  }, []);

  const Greeting = () => {
    var myDate = new Date();
    var hours = myDate.getHours();
    var greet;
    if (hours < 12) greet = "Morning";
    else if (hours >= 12 && hours <= 17) greet = "Afternoon";
    else if (hours >= 17 && hours <= 24) greet = "Evening";
    return <span>Good {greet}!</span>;
  };

  return (
    <Dashboard title="Dashboard" superAdmin={superAdmin}>
      <div className="w-full grid grid-cols-1 gap-4">
        <div className="bg-white shadow rounded-lg p-4 sm:p-6 xl:p-8 ">
          <Skeleton loading={loading}>
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <span className="text-2xl sm:text-3xl leading-none font-bold text-gray-900">
                  <Greeting />
                </span>
                <h3 className="text-base font-normal pt-1 text-gray-500">
                  {currentUser ? currentUser?.name : "N/A"}
                </h3>
                <h3 className="text-xl font-bold leading-none text-gray-900">
                  {superAdmin ? "You are a Super Admin." : ""}
                </h3>
              </div>
            </div>
          </Skeleton>
        </div>
      </div>
      <div className="mt-4 w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {superAdmin ? (
          <div className="bg-white shadow rounded-lg p-4 sm:p-6 xl:p-8 ">
            <Skeleton loading={loading}>
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <span className="text-2xl sm:text-3xl leading-none font-bold text-gray-900">
                    {data ? data?.length : 0}
                  </span>
                  <h3 className="text-base font-normal text-gray-500">
                    Total Stores
                  </h3>
                </div>
                <div className="ml-5 w-0 flex items-center justify-end flex-1 font-bold">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    fill="#1890FF"
                    className="bi bi-basket"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1v4.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 13.5V9a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1.217L5.07 1.243a.5.5 0 0 1 .686-.172zM2 9v4.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V9H2zM1 7v1h14V7H1zm3 3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 4 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 6 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 8 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5z" />
                  </svg>
                </div>
              </div>
            </Skeleton>
          </div>
        ) : (
          <>
            <div className="bg-white shadow rounded-lg p-4 sm:p-6 xl:p-8 ">
              <Skeleton loading={loading}>
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <span className="text-2xl sm:text-3xl leading-none font-bold text-gray-900">
                      {productCount ? productCount : 0}
                    </span>
                    <h3 className="text-base font-normal text-gray-500">
                      Total Products
                    </h3>
                  </div>
                  <div className="ml-5 w-0 flex items-center justify-end flex-1 font-bold">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="50"
                      height="50"
                      fill="#1890FF"
                      className="bi bi-boxes"
                      viewBox="0 0 16 16"
                    >
                      <path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434L7.752.066ZM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567L4.25 7.504ZM7.5 9.933l-2.75 1.571v3.134l2.75-1.571V9.933Zm1 3.134 2.75 1.571v-3.134L8.5 9.933v3.134Zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567-2.742 1.567Zm2.242-2.433V3.504L8.5 5.076V8.21l2.75-1.572ZM7.5 8.21V5.076L4.75 3.504v3.134L7.5 8.21ZM5.258 2.643 8 4.21l2.742-1.567L8 1.076 5.258 2.643ZM15 9.933l-2.75 1.571v3.134L15 13.067V9.933ZM3.75 14.638v-3.134L1 9.933v3.134l2.75 1.571Z" />
                    </svg>
                  </div>
                </div>
              </Skeleton>
            </div>
            <div className="bg-white shadow rounded-lg p-4 sm:p-6 xl:p-8 ">
              <Skeleton loading={loading}>
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <span className="text-2xl sm:text-3xl leading-none font-bold text-gray-900">
                      {orderCount ? orderCount : 0}
                    </span>
                    <h3 className="text-base font-normal text-gray-500">
                      Total Orders
                    </h3>
                  </div>
                  <div className="ml-5 w-0 flex items-center justify-end flex-1 font-bold">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="50"
                      height="50"
                      fill="#1890FF"
                      className="bi bi-basket"
                      viewBox="0 0 16 16"
                    >
                      <path d="M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1v4.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 13.5V9a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1.217L5.07 1.243a.5.5 0 0 1 .686-.172zM2 9v4.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V9H2zM1 7v1h14V7H1zm3 3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 4 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 6 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 8 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5z" />
                    </svg>
                  </div>
                </div>
              </Skeleton>
            </div>
            <div className="bg-white shadow rounded-lg p-4 sm:p-6 xl:p-8 ">
              <Skeleton loading={loading}>
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <span className="text-2xl sm:text-3xl leading-none font-bold text-gray-900">
                      {storeCurrency} {totalIncome ? totalIncome : 0}
                    </span>
                    <h3 className="text-base font-normal text-gray-500">
                      Total Income
                    </h3>
                  </div>
                  <div className="ml-5 w-0 flex items-center justify-end flex-1 font-bold">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="50"
                      height="50"
                      fill="#1890FF"
                      className="bi bi-cash"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
                      <path d="M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V6a2 2 0 0 1-2-2H3z" />
                    </svg>
                  </div>
                </div>
              </Skeleton>
            </div>
          </>
        )}
      </div>
      {userData?.length > 0 && !superAdmin ? (
        <div className="grid grid-cols-1 2xl:grid-cols-1 xl:gap-4 my-4">
          <div className="bg-white shadow rounded-lg mb-4 p-4 sm:p-6 h-full">
            <Skeleton loading={loading}>
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-bold leading-none text-gray-900">
                  Customers
                </h3>
                <a
                  href="/customers"
                  className="text-sm font-medium text-cyan-600 hover:bg-gray-100 rounded-lg inline-flex items-center p-2"
                >
                  View all
                </a>
              </div>
            </Skeleton>
            <Skeleton loading={loading}>
              <div className="relative rounded-xl overflow-auto">
                <div className="shadow-sm overflow-hidden my-8">
                  <table className="border-collapse table-fixed w-full text-sm">
                    <thead>
                      <tr>
                        <th className="border-b dark:border-slate-600 font-medium p-4 pl-8 pt-0 pb-3 text-slate-400 dark:text-slate-200 text-left">
                          Name
                        </th>
                        <th className="border-b dark:border-slate-600 font-medium p-4 pr-8 pt-0 pb-3 text-slate-400 dark:text-slate-200 text-left">
                          Email
                        </th>
                        <th className="border-b dark:border-slate-600 font-medium p-4 pr-8 pt-0 pb-3 text-slate-400 dark:text-slate-200 text-left">
                          Joined date
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white dark:bg-slate-800">
                      {userData?.map((user) => (
                        <tr key={user?._id}>
                          <td className="border-b border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-400">
                            {user?.name}
                          </td>
                          <td className="border-b border-slate-100 dark:border-slate-700 p-4 text-slate-500 dark:text-slate-400">
                            {user?.email}
                          </td>
                          <td className="border-b border-slate-100 dark:border-slate-700 p-4 pr-8 text-slate-500 dark:text-slate-400">
                            {formatDate(user?.createdAt)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </Skeleton>
          </div>
        </div>
      ) : (
        ""
      )}
    </Dashboard>
  );
};

export default Main;
